import { IconCalendar, IconClipboardList, IconLayoutDashboard, IconFileDescription } from '@tabler/icons-react';

const icons = {
  IconCalendar,
  IconClipboardList,
  IconLayoutDashboard,
  IconFileDescription
};

const rallyOfficer = {
  id: 'rally-officer',
  title: 'Rally Officer Tools',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/rally-officer/dashboard',
      icon: icons.IconLayoutDashboard,
      breadcrumbs: false
    },
    {
      id: 'manage-bookings',
      title: 'Rallies',
      type: 'item',
      url: '/rally-officer/manage-bookings',
      icon: icons.IconClipboardList,
      breadcrumbs: false
    },
    {
      id: 'documents',
      title: 'Documents',
      type: 'item',
      url: '/rally-officer/documents',
      icon: icons.IconFileDescription,
      breadcrumbs: false
    }
  ]
};

export default rallyOfficer;
